import { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { UserPassportForm } from "Bands/components";
import { editUserPassport, userPassportSelectorCreator } from "Bands/state";
import { IUserPassportPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { IdCard } from "shared/assets/icons";

const { userPassport: passportCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const EditUserPassportModal: FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const passportIdSelector = useMemo(() => userPassportSelectorCreator(id), [id]);
  const passport = useSelector(passportIdSelector);

  const buttons: IFormButtons = {
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserPassportPatchData) => {
    dispatch(editUserPassport({ id, data }));
  };

  const defaultValues = useMemo(() => {
    const files: { [key: string]: { id: string; originalURL: string } } = {};

    passport?.files.forEach(({ id, source }, index) => {
      if (!source) return;

      files[`files.${index}`] = { id, originalURL: source };
    });

    // show original uploaded files as preview
    return {
      ...passport,
      files,
    };
  }, [passport]);

  return (
    <UserEntityModal
      defaultValues={defaultValues}
      title={passportCopy.edit.title}
      icon={IdCard}
      action={USER_ACTIONS.editUserPassport}
      buttons={buttons}
      successMessage={passportCopy.messages.edited}
      Component={UserPassportForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
    />
  );
};
